
import { Outlet, Link } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <img src="https://static.readdy.ai/image/e50d925263add9c47b947a5709171c8c/894de08e385da480c4cd82df0969ba30.png" alt="EasyDigitalDVD" className="h-12" />
          </Link>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
